module.exports = __webpack_public_path__ + "img/黑名单.eceeb045.png";